<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="pictograms"/>
    <section class="p-4">
      <pictogram-admin-panel
        :pictogramId="pictogramId"
        @epc-go-back="_HandleGoBack"
      />
    </section>
  </div>
</template>

<script>
import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons';
import PictogramAdminPanel from '../../components/pictograms/pictogram-admin-panel.vue';

export default {
  name: 'AdminPictogram',
  middleware: 'auth',
  title: 'pictogram_configuration',

  components: { ProjectAdminQuickButtons, PictogramAdminPanel },

  computed: {
    pictogramId() {
      return parseInt(this.$route.params.id);
    },
  },

  methods: {
    _HandleGoBack() {
      this.$router.push({ name: 'project.admin.pictograms' });
    },
  },
};
</script>
